import React, { PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import { Container } from 'reactstrap';

import Sneakers from '../Sneakers';

export default class PopularProducts extends Component{
  render(){
    return(
      <Container fluid className="product-container">
        <h3 className="underline title black">
          <span>MOST POPULAR</span>
        </h3>
        <Sneakers/>
      </Container>
    )
  }
}